<div
  *ngIf="isSuccess || isUpdated || isError || isWarning"
  class="d-flex align-items-center justify-content-between"
  [ngClass]="{
    'bg-success': isSuccess,
    'bg-updated': isUpdated,
    'bg-error': isError,
    'bg-warning': isWarning
  }"
  id="alerts"
>
  <div class="mx-2">
    @if(isSuccess || isUpdated || isError || isWarning){
    <img [src]="getImageSrc()" [alt]="getAlertText()" />
    }
  </div>
  <div class="d-flex text-white">
    <div *ngIf="isSuccess">
      <h4>Successfully</h4>
      <h5>{{ successMsg }}</h5>
    </div>
    <div *ngIf="isUpdated">
      <h3>Updated</h3>
      <h5>{{ infoMsg }}</h5>
    </div>
    <div *ngIf="isError">
      <h3>Oh Snap!</h3>
      <h5>{{ errorMsg }}</h5>
    </div>
    <div *ngIf="isWarning">
      <h3>Warning</h3>
      <h5>{{ warningMsg }}</h5>
    </div>
    <span class="material-icons text-white pointer" (click)="closeAlert()"
      >close</span
    >
  </div>
</div>
